// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.job-details-header {
  text-align: left;
  font-weight: 500;
  font-size: 28px !important;
  line-height: 37px !important;
  letter-spacing: 0;
  color: #212121 !important;
  opacity: 1;
}

.job-details-seniority {
  text-align: left !important;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0;
  color: #444444 !important;
  opacity: 1;
}

.job-detail-skill-description {
  text-align: left;
  font-size: 14px !important;
  line-height: 22px;
  letter-spacing: 0;
  color: #888888 !important;
  opacity: 1;
}

.job-detail-skill-title {
  text-align: left;
  font-size: 20px !important;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0;
  color: #212121 !important;
  opacity: 1;
}

.job-detail-skill-wrapper {
  margin-top: 56px;
}

.job-details-skill-card {
  text-align: center !important;
  width: 180px;
  height: 272px;
  background: #FFFFFF 0% 0% no-repeat padding-box !important;
  box-shadow: 0 2px 4px #00000014 !important;
  border-radius: 4px !important;
  opacity: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 10px;
}

.job-details-skill-card > div {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  min-height: 36px;
}

.job-details-skill-card > div > button {
  text-align: center !important;
}

.job-details-skill-card-name {
  flex: 1;
  font-size: 16px;
  font-weight: 600;
}

.job-details-skill-icon {
  width: 64px;
  height: 64px;
}

.job-details-skill-name {
  text-align: center;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  color: #212121 !important;
  opacity: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.job-details-mcq-start {
    padding: 0 !important;
    text-align: left !important;
    font-size: 14px !important;
    height: 19px !important;
    font-weight: 500;
    line-height: 19px !important;
    letter-spacing: 0.56px !important;
    color: #56A8F7 !important;
    opacity: 1;
}

.job-details-mcq-start:hover {
  background: #fff
}

.job-details-mcq-pass {
  text-align: left;
  font-size: 14px !important;
  line-height: 22px !important;
  letter-spacing: 0;
  color: #66CC80 !important;
  opacity: 1;
}

.job-details-mcq-not-pass, .job-detail-mcq-time {
  text-align: center;
  font-size: 14px !important;
  line-height: 22px;
  letter-spacing: 0;
  color: #AAAAAA !important;
  opacity: 1;
}

.job-detail-desc-title {
  text-align: left;
  font-weight: 500;
  font-size: 20px !important;
  line-height: 26px;
  letter-spacing: 0;
  color: #212121 !important;
  opacity: 1;
}

.job-detail-desc-desc {
  text-align: left;
  font-size: 14px !important;
  line-height: 24px;
  letter-spacing: 0;
  color: #666666 !important;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/JobDetailComponent/index.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;EAC5B,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,0DAA0D;EAC1D,0CAA0C;EAC1C,6BAA6B;EAC7B,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;IACvB,gBAAgB;IAChB,4BAA4B;IAC5B,iCAAiC;IACjC,yBAAyB;IACzB,UAAU;AACd;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;EAC5B,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ","sourcesContent":[".job-details-header {\n  text-align: left;\n  font-weight: 500;\n  font-size: 28px !important;\n  line-height: 37px !important;\n  letter-spacing: 0;\n  color: #212121 !important;\n  opacity: 1;\n}\n\n.job-details-seniority {\n  text-align: left !important;\n  font-size: 16px;\n  line-height: 22px;\n  letter-spacing: 0;\n  color: #444444 !important;\n  opacity: 1;\n}\n\n.job-detail-skill-description {\n  text-align: left;\n  font-size: 14px !important;\n  line-height: 22px;\n  letter-spacing: 0;\n  color: #888888 !important;\n  opacity: 1;\n}\n\n.job-detail-skill-title {\n  text-align: left;\n  font-size: 20px !important;\n  font-weight: 500;\n  line-height: 26px;\n  letter-spacing: 0;\n  color: #212121 !important;\n  opacity: 1;\n}\n\n.job-detail-skill-wrapper {\n  margin-top: 56px;\n}\n\n.job-details-skill-card {\n  text-align: center !important;\n  width: 180px;\n  height: 272px;\n  background: #FFFFFF 0% 0% no-repeat padding-box !important;\n  box-shadow: 0 2px 4px #00000014 !important;\n  border-radius: 4px !important;\n  opacity: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px 10px;\n}\n\n.job-details-skill-card > div {\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  min-height: 36px;\n}\n\n.job-details-skill-card > div > button {\n  text-align: center !important;\n}\n\n.job-details-skill-card-name {\n  flex: 1;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.job-details-skill-icon {\n  width: 64px;\n  height: 64px;\n}\n\n.job-details-skill-name {\n  text-align: center;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 21px;\n  color: #212121 !important;\n  opacity: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n}\n\n.job-details-mcq-start {\n    padding: 0 !important;\n    text-align: left !important;\n    font-size: 14px !important;\n    height: 19px !important;\n    font-weight: 500;\n    line-height: 19px !important;\n    letter-spacing: 0.56px !important;\n    color: #56A8F7 !important;\n    opacity: 1;\n}\n\n.job-details-mcq-start:hover {\n  background: #fff\n}\n\n.job-details-mcq-pass {\n  text-align: left;\n  font-size: 14px !important;\n  line-height: 22px !important;\n  letter-spacing: 0;\n  color: #66CC80 !important;\n  opacity: 1;\n}\n\n.job-details-mcq-not-pass, .job-detail-mcq-time {\n  text-align: center;\n  font-size: 14px !important;\n  line-height: 22px;\n  letter-spacing: 0;\n  color: #AAAAAA !important;\n  opacity: 1;\n}\n\n.job-detail-desc-title {\n  text-align: left;\n  font-weight: 500;\n  font-size: 20px !important;\n  line-height: 26px;\n  letter-spacing: 0;\n  color: #212121 !important;\n  opacity: 1;\n}\n\n.job-detail-desc-desc {\n  text-align: left;\n  font-size: 14px !important;\n  line-height: 24px;\n  letter-spacing: 0;\n  color: #666666 !important;\n  opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
